import EmailTemplate from './EmailTemplate';

export default EmailTemplate;
